import http from '@/http'
import { DraftPageVersion } from '@/interfaces/admin'

export async function getDraftPageVersion (draftPageId: number): Promise<DraftPageVersion> {
  const { data } = await http.get(`/admin/draft-pages/${draftPageId}/latest-version`)
  return data
}
